import { inject, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  patchState,
  signalStoreFeature,
  withHooks,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import { TranslateService } from '@ngx-translate/core';
import { Language, LanguageState } from 'app/language/store/language.interfaces';
import { languagePersistance, loadLanguage } from 'app/language/store/language.utils';

const initialState: LanguageState = {
  supportedLanguages: Object.keys(Language) as Language[],
  currentLanguage: loadLanguage(),
};

export const useLanguage = () =>
  signalStoreFeature(
    withState<LanguageState>(initialState),
    withProps(() => ({
      _injector: inject(Injector),
      _dialogService: inject(MatDialog),
      _translateService: inject(TranslateService),
    })),
    withMethods(store => {
      const changeLanguage = (language: Language) => {
        languagePersistance.setLanguage(language);
        store._translateService.use(language);
        patchState(store, { currentLanguage: language });
      };

      const openLanguageDialog = async () => {
        const { ChangeLanguageDialogComponent } =
          await import('app/language/components/change-language-dialog/change-language-dialog.component');

        store._dialogService.open(ChangeLanguageDialogComponent, {
          autoFocus: false,
          injector: store._injector,
        });
      };

      return { changeLanguage, openLanguageDialog };
    }),
    withHooks({
      onInit(store) {
        store._translateService.use(store.currentLanguage());
      },
    }),
  );
